/*
 * @Author: Teemo Ding
 * @Date: 2022-02-17 15:27:02
 * @LastEditTime: 2022-06-06 10:38:23
 * @LastEditors: Json Chen
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Settings/Communication/Detail/CommunicationGateway/Components/Twilio.tsx
 */
//import { useRequest } from 'ahooks';
import React from 'react';
//import { getAreaCodeAll } from 'src/request/common';
import {
  AccountSIDAndAuthToken,
  SendSMSFrom,
} from '../../../Components/FormComponents';

const Twilio = ({
  editable,
  handleResetInput,
  unlockEditable,
  communicationUuid,
  disabled,
  //isPhoneValidation,
}) => {
  //const { data: areaCodes = [] } = useRequest(() => getAreaCodeAll());
  // const areaCodesOptions = areaCodes.map((item) => ({
  //   label: `+ ${item.areaCode}`,
  //   value: item.areaCode,
  //   uuid: item.uuid,
  // }));
  return (
    <div>
      <AccountSIDAndAuthToken
        editable={editable}
        communicationUuid={communicationUuid}
        handleResetInput={handleResetInput}
        unlockEditable={unlockEditable}
        disabled={disabled}
      />
      {
        <SendSMSFrom
          editable={editable}
          //areaCodesOptions={areaCodesOptions}
          disabled={disabled}
        />
      }
    </div>
  );
};

export default Twilio;
